"use client";

import { useEffect, useRef, useState } from "react";
import Player from "@vimeo/player";
import Button from "@/components/ui/Button";

export default function HeroVideo() {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const playerRef = useRef<Player | null>(null);

  const [showVideo, setShowVideo] = useState(false);
  const [hasSound, setHasSound] = useState(false);

  // detect desktop
  useEffect(() => {
    if (window.innerWidth >= 1024) {
      const t = setTimeout(() => setShowVideo(true), 1200); // lazy load
      return () => clearTimeout(t);
    }
  }, []);

  // init player
  useEffect(() => {
    if (!showVideo || !iframeRef.current) return;

    playerRef.current = new Player(iframeRef.current);

    playerRef.current.setMuted(true);
    playerRef.current.setVolume(0);
  }, [showVideo]);

  const toggleSound = async () => {
    if (!playerRef.current) return;

    if (hasSound) {
      await playerRef.current.setMuted(true);
      setHasSound(false);
    } else {
      await playerRef.current.setMuted(false);
      await playerRef.current.setVolume(1);
      setHasSound(true);
    }
  };

  if (!showVideo) return null;

  return (
    <div className="absolute inset-0 overflow-hidden bg-black">
      <iframe
        ref={iframeRef}
        src="https://player.vimeo.com/video/1164665171?autoplay=1&loop=1&muted=1&controls=0&title=0&byline=0&portrait=0&dnt=1"
        className="absolute left-1/2 top-1/2 h-full min-h-full w-full min-w-full -translate-x-1/2 -translate-y-1/2 scale-125"
        allow="autoplay; fullscreen"
      />

      <Button
        size={"small"}
        theme={"white"}
        onClick={toggleSound}
        className="absolute right-10 top-52 z-20 !w-auto gap-2.5 !rounded-full !bg-white/80"
      >
        {hasSound ? (
          <>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.9993 4L7.99935 12H2.66602V20H7.99935L15.9993 28V4ZM20.9421 11.0573L19.0566 12.9427L22.1139 16L19.0566 19.0573L20.9421 20.9427L23.9993 17.8854L27.0566 20.9427L28.9421 19.0573L25.8848 16L28.9421 12.9427L27.0566 11.0573L23.9993 14.1146L20.9421 11.0573Z"
                fill="#151922"
              />
            </svg>
            <span>Wyłącz dzwięk</span>
          </>
        ) : (
          <>
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.6673 4L6.66732 12H1.33398V20H6.66732L14.6673 28V4ZM25.9798 4.6875L24.0944 6.57292C29.3129 11.7914 29.3127 20.21 24.0944 25.4271L25.9798 27.3125C32.2175 21.0763 32.2173 10.925 25.9798 4.6875ZM22.209 8.45833L20.3236 10.3438C23.4594 13.4796 23.4592 18.5218 20.3236 21.6562L22.209 23.5417C26.364 19.3881 26.3638 12.6131 22.209 8.45833ZM18.4382 12.2292L16.5527 14.1146C17.6062 15.168 17.6062 16.832 16.5527 17.8854L18.4382 19.7734C20.51 17.7016 20.51 14.301 18.4382 12.2292Z"
                fill="#151922"
              />
            </svg>
            <span>Włącz dzwięk</span>
          </>
        )}
      </Button>
    </div>
  );
}
